import React from 'react'

const Calendar = () => {
  return (
    <div>Comming soon</div>
  )
}

export default Calendar